/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOrganizzazioneDto } from '../../models/create-organizzazione-dto';
import { OrganizzazioneResDto } from '../../models/organizzazione-res-dto';

export interface OrganizzazioniControllerCreateOrganizzazione$Params {
  body: CreateOrganizzazioneDto;
}

export function organizzazioniControllerCreateOrganizzazione(
  http: HttpClient,
  rootUrl: string,
  params: OrganizzazioniControllerCreateOrganizzazione$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<OrganizzazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    organizzazioniControllerCreateOrganizzazione.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrganizzazioneResDto>;
      }),
    );
}

organizzazioniControllerCreateOrganizzazione.PATH = '/admin/organizzazioni';
